const PREFIX = 'organisation_'
export const LOADING = PREFIX + 'LOADING'
export const UPDATE_ALL = PREFIX + 'UPDATE_ALL'
export const UPDATE_BY_ID = PREFIX + 'UPDATE_BY_ID'
export const UPDATE_MEMBERS = PREFIX + 'UPDATE_MEMBERS'
export const UPDATE_ALL_ORG_ACCESS = PREFIX + 'UPDATE_ALL_ORG_ACCESS'
export const UPDATE_ORG_ACCESS_BY_ID = PREFIX + 'UPDATE_ORG_ACCESS_BY_ID'